export function stripToDigits(value?: string | null) {
  if (!value) return "";
  return value.replace(/\D+/g, "");
}

function normalizeSouthAfricaBase(digits: string) {
  if (!digits) return "";
  if (digits.startsWith("00")) {
    return normalizeSouthAfricaBase(digits.slice(2));
  }
  if (digits.startsWith("27")) {
    return digits;
  }
  if (digits.startsWith("0") && digits.length === 10) {
    return `27${digits.slice(1)}`;
  }
  return digits;
}

export function normalizePhoneNumber(value?: string | null) {
  const digits = stripToDigits(value);
  if (!digits) return "";
  return normalizeSouthAfricaBase(digits);
}

export function buildPhoneMatchKeys(value?: string | null) {
  const digits = stripToDigits(value);
  if (!digits) return new Set<string>();

  const normalized = normalizeSouthAfricaBase(digits);
  const keys = new Set<string>();
  keys.add(digits);
  keys.add(normalized);

  if (normalized.startsWith("27") && normalized.length >= 11) {
    keys.add(`0${normalized.slice(2)}`);
  }

  if (digits.length > 10) {
    keys.add(digits.slice(-10));
  }

  if (normalized.length > 10) {
    keys.add(normalized.slice(-10));
  }

  return keys;
}

export function phonesMatch(a?: string | null, b?: string | null) {
  const keysA = buildPhoneMatchKeys(a);
  const keysB = buildPhoneMatchKeys(b);
  if (keysA.size === 0 || keysB.size === 0) return false;
  for (const key of keysA) {
    if (keysB.has(key)) return true;
  }
  return false;
}

export function formatPhoneForDisplay(value?: string | null) {
  const normalized = normalizePhoneNumber(value);
  if (!normalized) return "";
  if (normalized.startsWith("27") && normalized.length === 11) {
    return `+27 ${normalized.slice(2, 4)} ${normalized.slice(4, 7)} ${normalized.slice(7)}`;
  }
  return normalized;
}
